export const PRICE = '23 USD'

export const BRAND = 'Nail Educator Ready™'

/** Section 2 — interior pages, in this exact order. */
export const insidePages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/itmkgQe6fv35wv83xdVCgB/01-kit-complet-formatrice.webp',
    caption: 'Kit complet de la formatrice — Page 63',
    label: 'Tout ce qu’il vous faut pour enseigner',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gUwq9r9Tyq8AWFKseic2MF/02-architecture-3-vues.webp',
    caption: 'Architecture complète — 3 vues — Page 43',
    label: 'Enseignez l’architecture visuellement',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nnZGUEA52Pk3QCZny7o2N4/03-form-placement-diagnostic.webp',
    caption: 'Form Placement Diagnostic — Page 14',
    label: 'Aidez vos élèves à identifier leurs erreurs',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gHbzpwTWhyZaExZhZNmA3F/04-troubleshooting-avance.webp',
    caption: 'Troubleshooting avancé — Page 29',
    label: 'Corrigez avec une véritable méthode',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/32JHzfXK5W7QKW32AWE6cJ/05-final-extension-assessment.webp',
    caption: 'Final Extension Assessment — Page 39',
    label: 'Évaluez vos apprenantes avec structure',
  },
]

/** Section 3 — pain points. */
export const painPoints = [
  {
    title: 'Des heures à préparer vos cours',
    text: 'Vous savez ce que vous voulez enseigner, mais transformer vos connaissances en une formation structurée prend du temps.',
  },
  {
    title: '« Comment vais-je expliquer ça ? »',
    text: 'Une technique peut être facile à réaliser pour vous… mais beaucoup plus difficile à expliquer clairement à une apprenante.',
  },
  {
    title: 'Des élèves qui répètent les mêmes erreurs',
    text: 'Identifier une erreur est une chose. Savoir comment l’expliquer, la corriger et la faire retravailler en est une autre.',
  },
  {
    title: 'Des évaluations improvisées',
    text: 'Sans critères clairs, il devient difficile de mesurer objectivement la progression d’une apprenante.',
  },
]

/** Section 4 — the teaching method. */
export const teachingMethod = ['Expliquez', 'Démontrez', 'Faites pratiquer', 'Corrigez', 'Évaluez']

/** Section 5 — the six volumes. Accent colors match the covers in the mockup. */
export const volumes = [
  {
    number: 1,
    title: 'Science de l’ongle, sécurité & fondamentaux professionnels',
    description:
      'Construisez des bases solides pour enseigner l’anatomie, la sécurité, l’hygiène et les fondamentaux professionnels.',
    accent: '#F3E6D6',
  },
  {
    number: 2,
    title: 'Maîtrise de l’ongle naturel, préparation & techniques professionnelles',
    description:
      'Préparation, analyse et techniques essentielles pour construire une base technique cohérente.',
    accent: '#F6D5CB',
  },
  {
    number: 3,
    title: 'Systèmes gel & maîtrise de la manucure structurée',
    description: 'Structurez l’enseignement du gel, de l’application et de la manucure structurée.',
    accent: '#D8E4CE',
  },
  {
    number: 4,
    title: 'Acrylique, extensions & architecture professionnelle de l’ongle',
    description: 'Architecture, extensions, formes, placement et construction expliqués visuellement.',
    accent: '#D4E2EF',
  },
  {
    number: 5,
    title: 'Techniques avancées, ponceuse & troubleshooting professionnel',
    description:
      'Aidez vos apprenantes à comprendre les erreurs, leurs causes possibles et les stratégies de correction.',
    accent: '#E3D8F0',
  },
  {
    number: 6,
    title: 'Système professionnel d’enseignement & d’évaluation pour formatrices ongulaires',
    description:
      'Transformez vos connaissances en leçons, démonstrations, pratiques, feedback et évaluations structurées.',
    accent: '#F4E2C6',
  },
]

/** Section 6 — classic ebook vs. the system. */
export const classicEbook = [
  'Beaucoup de théorie',
  'À vous de créer le cours',
  'À vous de créer les exercices',
  'À vous d’organiser l’évaluation',
]

export const readySystem = [
  'Leçons structurées',
  'Démonstrations',
  'Exercices pratiques',
  'Troubleshooting',
  'Systèmes de correction',
  'Critères d’évaluation',
  'Ressources pour formatrices',
]

/** Section 7 — before and after. */
export const beforeItems = [
  '« Que dois-je préparer ? »',
  'Des heures de travail',
  'Ressources dispersées',
  'Corrections improvisées',
  'Évaluations difficiles à structurer',
]

export const afterItems = [
  'Une structure à suivre',
  'Des ressources disponibles',
  'Des explications visuelles',
  'Une méthode de correction',
  'Des critères d’évaluation',
  'Plus de temps pour réellement enseigner',
]

/** Section 8 — the five bonuses. */
export const bonuses = [
  {
    number: 'Bonus 1',
    title: 'Coffre de plans de cours Ready-to-Teach',
    description: 'Des plans de cours prêts à l’emploi pour structurer chaque séance sans partir de zéro.',
    accent: '#F6D5CB',
  },
  {
    number: 'Bonus 2',
    title: 'Coffre d’exercices & fiches pratiques pour apprenantes',
    description: 'Fiches, drills et exercices visuels prêts à donner à vos élèves pendant la formation.',
    accent: '#D8E4CE',
  },
  {
    number: 'Bonus 3',
    title: 'Kit d’évaluation & de suivi des apprenantes',
    description: 'Grilles d’évaluation, critères clairs et suivi de progression pour évaluer avec cohérence.',
    accent: '#D4E2EF',
  },
  {
    number: 'Bonus 4',
    title: 'Atlas visuel d’enseignement ongulaire',
    description: 'Schémas, diagrammes et références visuelles pour expliquer chaque technique clairement.',
    accent: '#E3D8F0',
  },
  {
    number: 'Bonus 5',
    title: 'Système de gestion de classe & des apprenantes',
    description: 'Registres, présences et outils d’organisation pour piloter vos formations sereinement.',
    accent: '#F4E2C6',
  },
]

/** Section 9 — who it is for. */
export const audience = [
  'Vous êtes formatrice ongulaire ou vous enseignez les techniques nails.',
  'Vous perdez trop de temps à préparer vos cours.',
  'Vous voulez mieux structurer vos démonstrations et exercices.',
  'Vous voulez expliquer les erreurs plus clairement.',
  'Vous souhaitez évaluer vos apprenantes avec davantage de cohérence.',
  'Vous avez l’expertise technique mais souhaitez améliorer votre méthode d’enseignement.',
]

/** Section 10 — value stack. */
export const offerIncludes = [
  '6 volumes complets',
  '5 bonus professionnels',
  'Ressources visuelles',
  'Exercices & drills',
  'Troubleshooting & corrections',
  'Outils d’évaluation',
  'Ressources pour formatrices',
  'Accès numérique immédiat',
]

export const faqs = [
  {
    question: 'Est-ce un produit physique ?',
    answer: 'Non. Nail Educator Ready™ est un produit numérique disponible en téléchargement.',
  },
  {
    question: 'À qui s’adresse ce système ?',
    answer:
      'Aux formatrices ongulaires et professionnelles qui enseignent ou souhaitent structurer davantage leurs formations.',
  },
  {
    question: 'Est-ce seulement de la théorie ?',
    answer:
      'Non. Le système combine contenu technique, ressources visuelles, exercices, troubleshooting, correction et outils d’évaluation.',
  },
  {
    question: 'Puis-je l’utiliser pour préparer mes formations ?',
    answer:
      'Oui. Le système est conçu comme une ressource Ready-to-Teach pour vous aider à organiser et structurer votre enseignement.',
  },
  {
    question: 'Dans quelle langue est-il disponible ?',
    answer: 'Cette édition est entièrement conçue en français.',
  },
  {
    question: 'Comment vais-je recevoir le produit ?',
    answer: 'L’accès numérique est fourni après confirmation de la commande.',
  },
  {
    question: 'Le paiement est-il sécurisé ?',
    answer:
      'Oui. Le paiement est sécurisé et crypté, et il est traité automatiquement dans votre devise locale.',
  },
  {
    question: 'Est-ce une certification officielle ?',
    answer:
      'Non. Nail Educator Ready™ est une ressource pédagogique professionnelle et ne constitue pas une certification, un diplôme ou une accréditation officielle.',
  },
]
